import { render, staticRenderFns } from "./LayoutStructureUser.vue?vue&type=template&id=0c76bda0&scoped=true"
import script from "./LayoutStructureUser.vue?vue&type=script&lang=js"
export * from "./LayoutStructureUser.vue?vue&type=script&lang=js"
import style0 from "./LayoutStructureUser.vue?vue&type=style&index=0&id=0c76bda0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c76bda0",
  null
  
)

export default component.exports